<template>
  <div class="deal-workflow-files">
    <v-btn
      v-if="showToggle"
      text
      x-small
      class="px-0 deal-workflow-files__toggle"
      @click="expanded = !expanded"
    >
      <v-icon x-small class="mr-1">{{ expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      {{ $t("DEALS.VIEW.FILES") }}
      <v-chip x-small class="ml-2">{{ fileCount }}</v-chip>
    </v-btn>

    <div v-if="!showToggle || expanded" :class="{ 'mt-2': showToggle }">
      <div class="mb-2">
        <div class="text-caption font-weight-medium">
          {{ $t("DEALS.VIEW.GENERATED_FILES") }}
        </div>
        <div v-if="!generatedFiles.length" class="grey--text text-caption">—</div>
        <div
          v-for="file in generatedFiles"
          :key="`gen-${file.id}`"
          class="deal-workflow-file-row"
        >
          <div class="deal-workflow-file-row__name">
            <v-icon small color="primary" class="mr-2">mdi-file-pdf-box</v-icon>
            <span>{{ file.original_name || file.name }}</span>
          </div>
          <div class="deal-workflow-file-row__actions">
            <span v-if="file.size" class="deal-workflow-file-row__size mr-2">
              {{ formatFileSize(file.size) }}
            </span>
            <v-btn
              icon
              x-small
              color="primary"
              :loading="downloadingFileId === file.id"
              :disabled="downloadingFileId !== null && downloadingFileId !== file.id"
              :aria-label="$t('GENERAL.LABELS.DOWNLOAD')"
              @click="$emit('download', file)"
            >
              <v-icon small>mdi-download</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <div>
        <div class="text-caption font-weight-medium">
          {{ $t("DEALS.VIEW.UPLOADED_FILES") }}
        </div>
        <div v-if="!uploadedFiles.length" class="grey--text text-caption">—</div>
        <div
          v-for="file in uploadedFiles"
          :key="`up-${file.id}`"
          class="deal-workflow-file-row"
        >
          <div class="deal-workflow-file-row__name">
            <v-icon small class="mr-2">mdi-file-outline</v-icon>
            <span>{{ file.original_name || file.name }}</span>
          </div>
          <div class="deal-workflow-file-row__actions">
            <span v-if="file.size" class="deal-workflow-file-row__size mr-2">
              {{ formatFileSize(file.size) }}
            </span>
            <v-btn
              icon
              x-small
              color="primary"
              :loading="downloadingFileId === file.id"
              :disabled="downloadingFileId !== null && downloadingFileId !== file.id"
              :aria-label="$t('GENERAL.LABELS.DOWNLOAD')"
              @click="$emit('download', file)"
            >
              <v-icon small>mdi-download</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatFileSize } from "@/views/pages/deals/dealWorkflowMeta";

export default {
  name: "DealWorkflowFiles",
  props: {
    files: {
      type: Object,
      default: () => ({ generated: [], uploaded: [] }),
    },
    downloadingFileId: {
      type: [Number, String],
      default: null,
    },
    defaultExpanded: {
      type: Boolean,
      default: false,
    },
    showToggle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      expanded: this.defaultExpanded || !this.showToggle,
    };
  },
  computed: {
    generatedFiles() {
      return this.files?.generated || [];
    },
    uploadedFiles() {
      return this.files?.uploaded || [];
    },
    fileCount() {
      return this.generatedFiles.length + this.uploadedFiles.length;
    },
  },
  methods: {
    formatFileSize,
  },
};
</script>

<style scoped>
.deal-workflow-files__toggle {
  min-width: 0;
  height: auto !important;
}

.deal-workflow-file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e3e6ef;
  border-radius: 6px;
  padding: 6px 8px;
}

.deal-workflow-file-row + .deal-workflow-file-row {
  margin-top: 6px;
}

.deal-workflow-file-row__name {
  display: flex;
  align-items: center;
  min-width: 0;
  margin-right: 8px;
}

.deal-workflow-file-row__name span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.deal-workflow-file-row__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.deal-workflow-file-row__size {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
</style>
